var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area_ui"},[(_vm.curZone.code)?_c('div',{staticClass:"area-box"},[_c('div',{staticClass:"area-name",on:{"click":_vm.showBox}},[_c('i',{staticClass:"iconweizhi2 iconfont"}),_vm._v(_vm._s(_vm.curZone.descript))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25efad2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/polymerization/Area.vue
// module id = null
// module chunks = 